import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_DOWNLOAD: GlameraIconDefinition = {
  name: 'download',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-download-group">
      <path class="glm-download-shaft" d="M12 3v12"></path>
      <path class="glm-download-head" d="m7 10 5 5 5-5"></path>
      <path class="glm-download-tray" d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-download-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './download.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class DownloadIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_DOWNLOAD;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
